import { useMemo } from 'react';
import { useCountdown } from 'root/src/client/v2/common/hooks/useCountdown';
import { GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { formatISOTimeLeft, getTimeLeftParts } from 'root/src/shared/util/timeUtil';
export function useGiveawayTimer(giveaway) {
    var _a, _b, _c, _d;
    const giveawayConfig = giveaway === null || giveaway === void 0 ? void 0 : giveaway.config;
    const minParticipantsToStart = (_a = giveawayConfig === null || giveawayConfig === void 0 ? void 0 : giveawayConfig.minParticipantsToStart) !== null && _a !== void 0 ? _a : null;
    const maxWaitTime = (_b = giveawayConfig === null || giveawayConfig === void 0 ? void 0 : giveawayConfig.maxWaitTime) !== null && _b !== void 0 ? _b : null;
    const isWaitingForParticipants = minParticipantsToStart !== null && !(giveaway === null || giveaway === void 0 ? void 0 : giveaway.endDate);
    const waitDeadline = useMemo(() => {
        if (!isWaitingForParticipants || !maxWaitTime || !(giveaway === null || giveaway === void 0 ? void 0 : giveaway.startDate)) {
            return null;
        }
        return new Date(new Date(giveaway.startDate).getTime() + maxWaitTime);
    }, [isWaitingForParticipants, maxWaitTime, giveaway === null || giveaway === void 0 ? void 0 : giveaway.startDate]);
    const currentParticipants = (_d = (_c = giveaway === null || giveaway === void 0 ? void 0 : giveaway.stats) === null || _c === void 0 ? void 0 : _c.participantCount) !== null && _d !== void 0 ? _d : 0;
    const participantsNeeded = minParticipantsToStart !== null
        ? Math.max(0, minParticipantsToStart - currentParticipants)
        : 0;
    const countdownTarget = isWaitingForParticipants && waitDeadline
        ? waitDeadline
        : ((giveaway === null || giveaway === void 0 ? void 0 : giveaway.endDate) || new Date());
    const { timeLeft, interval } = useCountdown(countdownTarget);
    const isPickingWinner = (giveaway === null || giveaway === void 0 ? void 0 : giveaway.status) === GiveawayStatus.Active
        && !isWaitingForParticipants
        && (giveaway === null || giveaway === void 0 ? void 0 : giveaway.endDate) !== null
        && timeLeft <= 0;
    const displayTimeLeft = Math.max(0, timeLeft);
    return {
        timeLeft,
        formattedISOTimeLeft: formatISOTimeLeft(displayTimeLeft),
        timeLeftParts: getTimeLeftParts(displayTimeLeft),
        isPickingWinner,
        isWaitingForParticipants,
        participantsNeeded,
        currentParticipants,
        minParticipantsToStart,
        interval,
    };
}
